import React from "react";
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
      <section id="footer" className="p-2 bg-dark text-center text-muted">
        <Container>
          <small>&#169; All Rights Reserved.{" "}Web Design&nbsp;by&nbsp;<a className="text-info"  target="_blank" rel="noopener noreferrer" href="https://www.cloud-engine.co.uk">Cloud Engine Limited</a>
          </small>
        </Container>
      </section>
  );
}

export default Footer;